import {FlowController} from '@mintdata-wsp/common/controllers/flow/FlowController';
import {pubControllers} from '@mintdata-wsp/pub/controllers/PubControllers';

export class PubFlowController extends FlowController
{
    public init():void
    {
        this.setCloudFunctions(pubControllers.integration.cloudFunctions);
    }
}
